
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcIntegrationBarDropdown as ObcIntegrationBarDropdownElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-bar-dropdown/integration-bar-dropdown.js';
 
 
 

 
 export const ObcIntegrationBarDropdown = createComponent({
   react: React,
   tagName: 'obc-integration-bar-dropdown',
   elementClass: ObcIntegrationBarDropdownElement,
   events: {
     
     onHomeButtonClicked: 'home-button-clicked' as EventName<CustomEvent<unknown>>,
     onDimmingButtonClicked: 'dimming-button-clicked' as EventName<CustomEvent<unknown>>,
     onNotificationButtonClicked: 'notification-button-clicked' as EventName<CustomEvent<unknown>>,
     onUserButtonClicked: 'user-button-clicked' as EventName<CustomEvent<unknown>>,
     onSystemButtonClicked: 'system-button-clicked' as EventName<CustomEvent<unknown>>,
   }
  });
 
 